export * from './config';

export { getMenuByLocale, getHeaderVariantByLocale, getFooterVariantByLocale, getLogoVariantByLocale } from './menu';
